// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + "Profile" + "." + "4ad84ba5" + ".chunk.css";
};